<template>
    <div class="container-fluid"> 
        <div class="row">
            <!-- 主体 -->
            <div class="col-md-12 box1">
                <div class="hepicture">
                    <!-- <img src="../../static/img/assets/black.png" alt=""> -->
                    <i class="backgroundImage"></i>
                    <p class="developer_banner_title_01">{{$t('developer_banner_title_01')}}</p>
                    <p class="developer_banner_text_01">{{$t('developer_banner_text_01')}}</p>
                </div>
                <div class="helanguage col-md-12">
                    <div style="width:100%;margin:auto;display:flex;">
                    <div class="lligence " style="margin-left:10%;">
                        <div>
                            <img src='../../static/img/home/home_artificial_intelligence.png' class="imgs1"  alt="">
                        </div>
                        <div class="hevoice">
                            <h3 style="margin-top: 9px;">{{$t('developer_feature_tool_ai')}}</h3>
                            <p>
                                {{$t('developer_feature_tool_description_ai')}}
                            </p>
                        </div>
                    </div>

                    <div class="lligence lligencePaddingStyle">
                        <div>
                            <img src='../../static/img/home/home_body_representation.png' class="imgs1" alt="">
                        </div>
                        <div class="hevoice">
                            <h3>{{$t('developer_feature_tool_motion')}}</h3>
                            <p>
                                {{$t('developer_feature_tool_description_motion')}}
                            </p>
                        </div>
                    </div>
                    <div class="lligence">
                        <div>
                            <img src='../../static/img/home/home_development_tools.png' class="imgs1" alt="">
                        </div>
                        <div class="hevoice">
                            <h3 style="margin-top: 8px;">{{$t('developer_feature_tool_devtool')}}</h3>
                            <p>
                                {{$t('developer_feature_tool_description_devtool')}}              
                            </p>
                        </div>
                    </div>
                    </div>
                </div>
                <!-- 小丹应用 -->
                <div class="hepepep col-md-12">
                    <div class="hefowawa">
                        <h1>{{$t('developer_feature_step_title')}}</h1>
                        <p>{{$t('developer_feature_step_text')}}</p>
                    </div>

                    <div class="heboxea row ">
                    <div class="" style="width:100%;margin:auto;">
                    <div class="heboxea">
                        <div class="heyinye heyinyeMargin">
                            <div class="heaksas">
                                <div class="imgs">
                                    <img src="../../static/img/home/home_login_develop.png" alt="">
                                </div>
                                <h3>{{$t('developer_feature_step_sign')}}</h3>
                                <p>{{$t('developer_feature_step_description_sign')}}</p>
                            </div>
                            <div class="imhse1">
                                <img src="../../static/img/home/home_right.png" alt="">
                            </div>
                        </div>
                        <div class="heyinye">
                            <div class="heaksas">
                                <div class="imgs">
                                    <!-- <img src="../../static/img/home/home_creation_development.png" alt=""> -->
                                    <img src="../../static/img/home/home_creation_development.jpg" alt="">
                                </div>
                                <h3>{{$t('developer_feature_step_creat')}}</h3>
                                <p>{{$t('developer_feature_step_description_creat')}}</p>
                            </div>

                            <div class="imhse1 imagsAuto">
                                <img src="../../static/img/home/home_right.png" alt="">
                            </div>
                        </div>
                        <div class="heyinye">
                            <div class="heaksas">
                                <div class="imgs">
                                    <!-- <img src="../../static/img/home/home_product_validation.png" alt=""> -->
                                    <img src="../../static/img/home/home_product_validation.jpg" alt="">
                                </div>
                                <h3>{{$t('developer_feature_step_product')}}</h3>
                                <p>{{$t('developer_feature_step_description_product')}}</p>
                            </div>

                            <div class="imhse1">
                                <img src="../../static/img/home/home_right.png" alt="">
                            </div>
                        </div>
                        <div class="heyinye">
                            <div class="heaksas">
                                <div class="imgs">
                                    <img src="../../static/img/home/home_mall_release.jpg" alt="">
                                    <!-- <img src="../../static/img/home/home_mall_release.png" alt=""> -->
                                </div>
                                <h3>{{$t('developer_feature_step_store')}}</h3>
                                <p>{{$t('developer_feature_step_description_store')}}</p>
                            </div>
                        </div>
                    </div>
                    </div>
                    </div>
                    <div class="divBtn">
                        <button  @click="btnBecomBtn" class="btnBecomDe">{{$t('registerTitle')}}</button>
                    </div>
                </div>
                 <!-- 技术支持 -->
                <div class="technology col-md-12">
                    <h3>{{$t('developer_feature_support_title')}}</h3>
                    <div class="helogy">
                        <div class="helogy-1">
                            <div class="imseag1">
                                <img src="../../static/img/home/home_robot_sdk.png" alt="">
                            </div>
                            <h4>Nuwa Robot SDK</h4>
                            <p>{{ $t('technicalSupportSdk') }}</p>
                        </div>
                        <div class="helogy-2">
                            <div class="imseag2">
                                <img src="../../static/img/home/home_motion.png" alt="">
                            </div>
                            <h4>{{ $t('technicalSupportAction') }}</h4>
                            <p>{{ $t('technicalSupportMotion') }}</p>
                        </div>
                    </div>
                </div>
                <!-- 购买 -->
                <div class="hegoumai">
                    <div class="heimhsase1">
                        <img src="../../static/img/home/home_footer_img.png" alt="">
                        <span @click="buyFn" class="btnBecomDe positionBuyBtn">{{$t('buy_now')}}</span>
                        <p class="developer_banner_buy">{{$t('developer_banner_buy')}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        data () {
            return {
                _href: '',
                base: 'https://www.nuwarobotics.'
            }
        },
        methods: {
            btnBecomBtn () {
                this.$store.state.borderStyle = 'developmentPlan'
                localStorage.setItem('clickState', 'developmentPlan')
                this.$router.push({name: 'introduces'})
            },
            buyFn () {
                if (localStorage.language === 'zh-CN') {
                    this._href = this.base + 'cn/'
                } else {
                    this._href = this.base + 'com/'
                }
                window.location.href = this._href
            }
        }
    }
</script>

<style scoped>
    * {
        padding: 0 !important;
    }
    .backgroundImage{
        display: inline-block;
        background-image: url('../../static/img/home/home_header_img.png');
        width: 100%;
        height: 0px;
        padding-top: 50%!important;
        position: relative;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
    }
    .developer_banner_buy {
        /* width: 592px; */
        height: 59px;
        font-family: sans-serif;
        font-size: 40px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 2.2px;
        color: var(--black);
        position: absolute;
        left: 15%;
        bottom: 5.2%;
        margin: 0;

    }
    .developer_banner_title_01 {
        /* width: 352px; */
        height: 59px;
        font-family: sans-serif;
        font-size: 40px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 2.2px;
        text-align: center;
        color: #ffffff;
        position: absolute;
        left: 7%;
        top: 21.6%;
        margin-bottom: 0;
    }
    .developer_banner_text_01{
        /* width: 481px; */
        height: 33px;
        font-family: sans-serif;
        font-size: 22px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        text-align: center;
        color: #ffffff;
        position: absolute;
        left: 7%;
        top: 30.9%;
        margin-bottom: 0;
        margin-left: 2px;
    }
    .positionBuyBtn{
        position: absolute;
        left: 24%;
        bottom: 3%;
    }
    .box1{
        margin-top: -2px!important;
    }
    .container {
        width: 1114px;
    }

    .box {
        height: 60px;
        display: flex;
        justify-content: space-between;
    }

    .box2 {
        height: 540px;
        background: #333333;
    }

    ul {
        list-style: none;
    }

    .box-1 {
        width: 480px;

    }

    .box-2 {
        width: 800px;

    }

    /* 主体 */
    .hepicture {
        width: 100%;
        height: 29%;
        font-size: 0;
        position: relative;
    }

    .hepicture img {
        width: 100%;
        height: 100%;
    }

    .helanguage {
        width: 100%;
        background-color: #ffffff;
        padding-top:92px!important; 
        padding-bottom:100px!important; 
    }

    .lligence {
        width: 21.5%;
        display: inline-block;
    }
    .lligencePaddingStyle{
        margin-left: 7.6%!important;
        margin-right: 7.6%!important;
    }
    .lligence .imgs {
        width: 200px;
        height: 200px;
        display: block;
        margin: auto;
    }

    .lligence .imgs1 {
        width: 170px;
        height: 170px;
        /* margin-left: 55px; */
        display: block;
        margin: auto;
    }

    .hevoice {
        text-align: center;
    }

    .hevoice h3 {
        /* font-size: 24px; */
         /* width: 186px; */
        height: 33px;
        font-family: sans-serif;
        font-size: 22px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: 33px;
        letter-spacing: 1.2px;
        text-align: center;
        color: #333333;
        margin-top: 14px;
    }

    .hevoice p {
        /* width: 310px; */
        /* height: 80px; */
        margin-bottom: 0px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        text-align: center;
        color: #333333;
    }

    /*小丹应用*/
    .hepepep {
        width: 100%;
        background: #e5f9fc;
        padding-bottom: 62px !important;
    }

    .heboxea {
        display: flex;
        justify-content: center;
    }
    .heaksas {
        width: 200px;
    }

    .heaksas h3 {
        text-align: center;
        font-size: 28px;
        /* width: 117px; */
        /* height: 33px; */
        font-family: sans-serif;
        font-size: 22px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        text-align: center;
        color: #333333;
        color: var(--black);
        margin-top: 10px;
        margin-bottom: 10px;

    }

    .heaksas p {
        font-size: 16px;
        text-align: center;
        color: #676d6e;
        /* width: 200px; */
        height: 80px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        text-align: center;
        color: #333333;
        color: var(--black);
    }

    .imgs {
        text-align: center;
    }

    .imgs img {
        background: #fff;
        border-radius: 8px;
        /* width: 150px; */
        /* height: 150px; */
    }

    .imhse1 {
        width: 50px;
        text-align: center;
    }

    .imhse1 img {
        width: 28px;
        height: 36px;
        margin-top: 101px;
        margin-left: 14px;
        margin-right: 22px;
    }

    .imagsAuto{
        margin-left: 22px!important;
        margin-right: 22px!important;
    }

    .heyinye {
        display: flex;
    }

    .hefowawa {
        padding-bottom: 30px !important;
        padding-top: 60px !important;
        text-align: center;
    }

    .hefowawa h1 {
        font-size: 50px;
        /* width: 338px; */
        height: 59px;
        font-family: sans-serif;
        font-size: 40px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 2.2px;
        color: #333333;
        margin: 0;
    }

    .hefowawa p {
        color: #676d6e;
        font-size: 28px;
        /* width: 302px; */
        height: 33px;
        font-family: sans-serif;
        font-size: 22px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        color: rgba(51, 51, 51, 0.5);
        margin: 0;
    }

    .divBtn {
        width: 100%;
        margin-top: 50px;
    }

    .btnBecomDe {
        width: 220px;
        height: 50px;
        border-radius: 10px;
        background-color: rgba(255, 255, 255, 0.3);
        border: solid 2.5px #00b5e2;
        font-family: sans-serif;
        font-size: 22px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        text-align: center;
        color: #00b5e2;
        outline: none;
        display: block;
        margin: auto;
        cursor: pointer;
        line-height: 46px;
    }
  /*技术支持*/
    .technology {
        width: 100%;
        background-color:#ffffff; 
        padding-bottom: 112px!important;
        padding-top: 70px!important;
    }

    .technology h3 {
        text-align: center;
        font-size: 50px;
        /* padding-top: 70px; */
        margin: 0;
        margin-bottom:50px; 
        /* width: 169px; */
        height: 59px;
        font-family: sans-serif;
        font-size: 40px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 2.2px;
        color: #333333;
        color: var(--black);
    }

    .helogy {
        width: 770px;
        margin: auto;
        display: flex;
        justify-content: space-between;
    }

    .helogy-1 {
        width: 310px;
        height: 300px;
        border-radius: 10px;
        background-color: #ffffff;
        border: solid 3px rgba(0,224,218,.5);
    }

    .helogy-1 h4 {
        text-align: center;
        /* margin-top: 30px; */
        margin: 10px 0px;
        color: #42c9ea;
        height: 33px;
        font-family: sans-serif;
        font-size: 22px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 33px;
        letter-spacing: 1.2px;
        text-align: center;
        color: #00b5e2;
    }

    .helogy-1 p {
        text-align: center;
        width: 266px;
        height: 80px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #333333;
        margin: auto;
    }

    .helogy-2 {
        width: 310px;
        height: 300px;
        /* opacity: 0.5; */
        border-radius: 10px;
        background-color: #ffffff;
        border: solid 3px rgba(0,224,218,.5);
    }

    .imseag1 {
        text-align: center;
        margin-top: 47px;
    }

    .imseag1 img {
        width: 100px;
        height: 100px;
    }

    .imseag2 {
        text-align: center;
        margin-top: 47px;
    }

    .imseag2 img {
        width: 100px;
        height: 100px;
    }

    .helogy-2 h4 {
        text-align: center;
        margin: 10px 0px;
        color: #42c9ea;
        height: 33px;
        font-family: sans-serif;
        font-size: 22px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 33px;
        letter-spacing: 1.2px;
        text-align: center;
        color: #00b5e2;
    }

    .helogy-2 p {
        text-align: center;
        width: 240px;
        height: 80px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #333333;
        margin: auto;
    }

    /*  购买  */
    .hegoumai {
        width: 100%;
        /* height: 300px; */
    }

    .heimhsase1 {
        text-align: center;
        /* position: relative; */
    }

    .heimhsase1 img {
        width: 100%;
        /* height: 300px; */
    }
</style>



// WEBPACK FOOTER //
// info.vue?f896cfe4